<template>
  <div class="page">
    <div class="content">
      <p v-if="!src && !url">登录中...</p>
      <template v-else>
        <div v-if="src">
          <div class="header">使用微信扫码登录</div>
          <img class="codeImg" :src="src" alt="" />
        </div>
        <div class="mobile-login" v-if="url">
          <div class="title">欢迎使用立吉答题</div>
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/2ec8956486a4561b787e8cc18b8d9f1a.svg"
            alt=""
          />
          <div class="login-btn" @click="openwx">一键登录</div>
        </div>

        <p class="tips">
          登录即表示同意<span @click="toFile('terms')">使用协议</span>和<span
            @click="toFile('privacy')"
            >隐私协议</span
          >
        </p>
        <div class="info" v-if="loginTip">
          <p class="title">新建答题提示</p>
          <p class="desc">
            1.扫码登录成功后，在手机上点击【创建答题】进入立吉答题小程序，选择需要的答题模式，录入题目/编辑设置；
          </p>
          <div class="imgGroup flex">
            <img
              class="flex1"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220420/a073a435a7160f4d114d93e8217cd17d.jpg"
              alt=""
            />
            <img
              class="flex1"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220420/b6a94793bea18b0e9da7d15fbb4e5b94.jpg"
              alt=""
            />
          </div>
          <p class="desc">2.完成创建后，在电脑上点击【刷新】即可开始使用</p>
          <img
            class="refreshImg"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220420/95bd57dcd0a5f121a116770a0c4a62f8.jpg"
            alt=""
          />
        </div>
        <Contact :fixed="true" />
      </template>
    </div>
  </div>
</template>
<script>
import { randomString, isMobile } from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import Contact from "@/components/contact";
import api from "@/utils/api";
import { Toast } from "vant";
import { handleZI } from "../../utils/common";
let intervalAsk = null;
let checkTime = 0;
export default {
  components: { Contact },
  data() {
    return {
      src: "",
      errcode: "",
      config: "",
      loginTip: false,
      url: "",
      auth_code: "",
      res: ''
    };
  },
  mounted() {
    let { auth_code } = this.$route.query;
    this.auth_code = auth_code;
    if (auth_code || !wemeet.app.isTMWebview()) {
      this.getAuthInfo(auth_code);
    } else {
      this.requestAuth();
    }
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  destroyed() {
    if (this.loginTip) localStorage.removeItem("loginTip");
    window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  methods: {
    disableBrowserBack() {
      this.$router.push({ name: "questionList" });
    },
    openwx() {
      window.location.href = this.url;
    },
    toFile(type) {
      this.$router.push({ name: type });
    },
    requestAuth() {
      let state = randomString(16);
      window.wemeet.permission
        .requestAuth({
          sdkId: api.sdkId,
          corpId: 213872664,
          redirectURI: "https://" + api.hostName + ".xiaoxiaodati.com/login",
          state
        })
        .then(() => {})
        .catch(err => {
          Toast(err);
        });
    },
    getAuthInfo(auth_code) {
      let param = {
        auth_code,
        ref_url: window.location.href,
        app_type: api.test ? 1 : 0,
        ...(isMobile() ? { source: 1 } : {})
      };
      questionOnly.get(api.question.getAuthInfo, param).then(res => {
        this.res = JSON.stringify(res);
        if (res.sta == 0) {
          if (res.data.access_token) {
            this.handleLogin(res.data);
          } else {
            this.url = res.data.url || "";
            this.loginTip = localStorage.getItem("loginTip") || false;
            this.src = res.data.qrcode || "";
            this.checkLoginSuccess(res.data.random_key, res.data.access_token);
          }
        } else if (res.sta == -1 && res.errcode === 109) {
          Toast("身份已过期请重新授权登录");
          setTimeout(() => {
            this.requestAuth();
          }, 1000);
        } else {
          Toast(res.msg);
        }
      });
    },
    checkLoginSuccess(random_key, access_token) {
      if (intervalAsk) clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 190) {
        checkTime = 0;
        this.requestAuth();
        return;
      }
      let parm = {
        random_key,
        access_token
      };
      questionOnly.get(api.question.checkBindStatus, parm).then(async res => {
        if (res.sta === 0) {
          if (!res.data.status) {
            clearTimeout(intervalAsk);
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(random_key, access_token);
            }, 3000);
          } else {
            this.handleLogin(res.data);
          }
        } else {
          clearTimeout(intervalAsk);
          intervalAsk = null;
          Toast(res.msg);
        }
      });
    },
    handleLogin(data) {
      let config = {
        sdkId: api.sdkId,
        corpId: "213872664",
        signature: data.signature,
        nonceStr: data.nonce_str,
        timestamp: data.timestamp
      };
      this.config = JSON.stringify(config);
      wemeet.permission
        .agentConfig(config)
        .then(res => {
          wemeet.meeting
            .getUserInfo()
            .then(resp => {
              let { nickname = "" } = resp;
              localStorage.setItem("meet_name", nickname);
            })
            .catch(err => {
              Toast(JSON.stringify(err));
            });
        })
        .catch(err => {
          Toast("登录页鉴权fail");
        });
      Toast("登录成功");
      localStorage.setItem("token", data.access_token);
      handleZI(data.mp_openid)
      setTimeout(() => {
        this.$router.replace({ name: "questionList" });
      }, 800);
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  background: #fff;
  height: auto;
  min-height: 100vh;
  padding-top: 64px;
  padding-bottom: rem(120);
  box-sizing: border-box;
}
.content {
  text-align: center;
  font-size: rem(40);
  .header {
    padding: rem(60) 0;
    word-wrap: break-word;
    word-break: normal;
    font-weight: 700;
  }
  .codeImg {
    width: rem(420);
    height: rem(420);
  }
  .tips {
    font-size: rem(24);
    margin: rem(30) 0 rem(30);
    span {
      color: #1890ff;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.imgGroup {
  display: flex;
  align-items: center;
  img {
    width: rem(311);
    height: rem(282);
    margin-bottom: rem(30);
  }
  img:first-child {
    margin-right: rem(12);
  }
}
.refreshImg {
  width: rem(420);
  height: rem(274);
  display: block;
  margin: 0 auto;
}
.info {
  text-align: left;
  margin: rem(60) rem(60) 0;
  font-size: rem(28);
  line-height: rem(42);
  color: #262626;
  .title {
    font-weight: 700;
    font-size: rem(34);
    line-height: rem(51);
    margin-bottom: rem(30);
  }
  .desc {
    margin-bottom: rem(30);
  }
}
.login-btn {
  height: rem(86);
  line-height: rem(86);
  background: #1890ff;
  color: #fff;
  font-size: rem(32);
  border-radius: rem(8);
  cursor: pointer;
  margin: rem(80) rem(30) 0;
}
.mobile-login {
  text-align: center;
  .title {
    font-weight: 700;
    font-size: rem(40);
    margin-bottom: rem(80);
  }
  img {
    width: rem(120);
    height: rem(120);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/loginfact.vue